const AddonRoutes = {
  getAddons: 'addon',
};

export default AddonRoutes